import React from "react";
import { useTranslation } from "react-i18next";
import PolicyRequired from "enums/PolicyRequired";

interface RenderCardSettingPolicyProps {
  policy: PolicyRequired;
  secondPolicy?: PolicyRequired;
}

const RenderCardSettingPolicy: React.FC<RenderCardSettingPolicyProps> = ({
  policy,
  secondPolicy,
}) => {
  const { t } = useTranslation();

  const getPolicyText = (policy: PolicyRequired) => {
    if (policy === PolicyRequired.required) {
      return t("Required Policy");
    } else if (policy === PolicyRequired.policy) {
      return t("Follow Policy");
    } else if (policy === PolicyRequired.not_required) {
      return t("Not Required");
    }
    return "";
  };

  const getPolicyShortText = (policy: PolicyRequired) => {
    if (policy === PolicyRequired.required) {
      return t("Required");
    } else if (policy === PolicyRequired.policy) {
      return t("Follow");
    } else if (policy === PolicyRequired.not_required) {
      return t("Not Required");
    }
    return "";
  };

  if (secondPolicy) {
    const primaryPolicyText = getPolicyShortText(policy);
    const secondaryPolicyText = getPolicyShortText(secondPolicy);
    return (
      <table>
        <tbody>
          <tr>
            <td style={{ paddingBottom: 4, paddingRight: 8 }}>
              {t("Allocations")}:
            </td>
            <td style={{ paddingInline: 8 }}>{primaryPolicyText}</td>
          </tr>
          <tr>
            <td style={{ paddingRight: 8 }}>{t("Receipts")}:</td>
            <td style={{ paddingInline: 8 }}>{secondaryPolicyText}</td>
          </tr>
        </tbody>
      </table>
    );
  }
  const primaryPolicyText = getPolicyText(policy);

  return <>{primaryPolicyText}</>;
};

export default RenderCardSettingPolicy;
